/**
 * Created by Amir Absaliamov on 09.09.2026.
 */

const TextHighlightValidation = {
    check: function (text) {
        if (!cleverapps.config.debugMode || typeof text !== "string" || !text) {
            return;
        }

        const message = Messages.has(text) || text;

        if (!TextHighlightValidation.isPhrase(message) || TextHighlightValidation.hasHighlight(message)) {
            return;
        }

        const snippet = message.length > 80 ? `${message.slice(0, 77)}...` : message;

        console.warn("TextHighlightValidation: force text has no highlighted word/phrase:", snippet);

        cleverapps.notification.create(`No text highlight: ${snippet}`);
    },

    isPhrase: function (text) {
        return text.includes(" ") || text.length > 15;
    },

    hasHighlight: function (text) {
        return Messages.splitByEmTags(text).some((part) => part.isEmphasized);
    }
};
